const recently_viewed_section = document.querySelector('.recently-viewed');

const options = {
	rootMargin: '100px'
}

const observer = new IntersectionObserver(entry => {

    if (entry[0].isIntersecting == true) {

        observer.unobserve(recently_viewed_section)
    
        let rec_prods = localStorage.getItem('recentlyViewedProductHandles');
        if (rec_prods) {
            rec_prods_arr = rec_prods.replace("[","").replace("]","").split(',');
            
            let recently_viewed = document.querySelector('.recently-viewed-slider');
            
            rec_prods_arr.forEach(rec_prod => {
                let handle = rec_prod.replace(/"/g,'');
        
                fetch(window.Shopify.routes.root + `products/${handle}?view=card&section_id=v2-recently-viewed-product-card`)
                  .then(response => {
                    if (response.ok) {
                      return response.text();
                    } else {
                      throw new Error("Error: " + response.status);
                    }
                  })
                  .then(data => {
                    const htmlDocument = new DOMParser().parseFromString(data, "text/html");
                    const productCard = htmlDocument.documentElement.querySelector(".product-card");
                    let url = window.location.href + "#";
                    let swiper_slide = document.createElement("div");
                    swiper_slide.classList.add('swiper-slide');
                    swiper_slide.insertAdjacentHTML('afterbegin', productCard.outerHTML);

                    if (productCard !== url) {
                      recently_viewed.insertAdjacentHTML('afterbegin', swiper_slide.outerHTML);
                    }

                    // Set offset padding for large screens
                    const screenWidth = window.innerWidth;
                    const fcontainerWidth = 1440;
                    const offsetDiff = Math.max(0, (screenWidth - fcontainerWidth) / 2);

                    const recent_swiper = new window.swiper('.recently-swiper', {
                      slidesPerView: 1.5,
                      spaceBetween: 16,
                      slidesOffsetBefore: 20,
                      slidesOffsetAfter: 20,
                      breakpoints: {
                        768: {
                          slidesPerView: 2.5,
                          slidesOffsetBefore: 58,
                          slidesOffsetAfter: 58
                        },
                        1024: {
                          slidesPerView: 3.5,
                          slidesOffsetBefore: 58,
                          slidesOffsetAfter: 58
                        },
                        1416: {
                          slidesPerView: 3.5,
                          slidesOffsetBefore: offsetDiff,
                          slidesOffsetAfter: offsetDiff
                        }
                      },
                      lazy: {
                        enabled: true,
                        checkInView: false,
                        loadOnTransitionStart: true,
                        loadPrevNext: true,
                        loadPrevNextAmount: 1
                      },
                      pagination: {
                        el: '.recently-viewed-swiper-counter', // Element to display pagination
                        type: 'fraction', // Display fraction (e.g., 1/6)
                      },
                      navigation: {
                        nextEl: '.recently-viewed-swiper-button-next',
                        prevEl: '.recently-viewed-swiper-button-prev',
                      },
                    });
                  })
                  .catch(error => {
                    console.error(error);
                  });

            });
            
        }
    }

  
}, options)

observer.observe(recently_viewed_section)